import { useHead } from "../services/common";

import Content from "../components/Content";

export default function DepartmentsAndSocieties() {

    useHead({
        title: "Sportovní oddíly a spolky | T.J. Sokol Poniklá",
        description: "Nabídka sportovních oddílů (volejbal, aerobik, Sokolíček pro děti) a spolků působících pod T.J. Sokol Poniklá. Přidejte se k nám!"
    });

    return <>
        <div className="header">
            <h1>Oddíly a spolky</h1>
        </div>
        <section className="width-max">
            <Content id="departments-and-societies" />
        </section>
    </>;
}